// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules_temp/buddy/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules_temp/buddy/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#hQKyD5I4GDhfz04LQ21H > div {\n    margin-bottom: 1em;\n}\n\n#hWobGlTqTlJFqR9OwH3B {\n    position: relative;\n    height: 100%;\n}\n", "",{"version":3,"sources":["webpack://./src/fe/index/main.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB","sourcesContent":["#menu > div {\n    margin-bottom: 1em;\n}\n\n#main {\n    position: relative;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": "hQKyD5I4GDhfz04LQ21H",
	"main": "hWobGlTqTlJFqR9OwH3B"
};
export default ___CSS_LOADER_EXPORT___;
